import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";

import { API_BASE_URL } from "../core/api-base-url";
import { IIndustryItem } from "@skills-app/models/industry";

type HttpOptions = {
  headers: HttpHeaders;
};

@Injectable({ providedIn: "root" })
export class IndustryService {
  /**
   * API_BASE_URL is "/api" in this repo.
   * Correct endpoint: `${API_BASE_URL}/industry`
   */
  private readonly endpoint = `${API_BASE_URL}/industry`;

  private readonly options: HttpOptions = {
    headers: new HttpHeaders({ "Content-Type": "application/json" }),
  };

  constructor(private readonly http: HttpClient) {}

  public getIndustryOptions(): Observable<IIndustryItem[]> {
    return this.http.get<IIndustryItem[]>(`${this.endpoint}/`, this.options);
  }
}
